import ProtectIcon from './ProtectIcon'
import ATOIcon from './ATOIcon'
import CloudiaIcon from './CloudiaIcon'
import MiroIcon from './MiroIcon'
import CloudGuardSaaSColoredIcon from './CloudGuardSaaSColoredIcon'
import CheckpointInfinityPortalIcon from './CheckpointInfinityPortalIcon'
import IdentityProtectionIcon from './IdentityProtectionIcon'
import IdentityIcon from './IdentityIcon'
import AssetsIcon from './AssetsIcon'
import DlpIcon from './DlpIcon'
import VisibilityIcon from './VisibilityIcon'
import CloudiaColoredIcon from './CloudiaColoredIcon'
import EndpointColoredIcon from './EndpointColoredIcon'
import EndpointDashboardColoredIcon from './EndpointDashboardColoredIcon'
import SandblastMobileIcon from './SandblastMobileIcon'
import DataTubeIcon from './DataTubeIcon'
import MAASIcon from './MAASIcon'
import MiroColoredIcon from './MiroColoredIcon'
import ThreatPreventionIcon from './ThreatPreventionIcon'
import Dome9ColoredIcon from './Dome9ColoredIcon'
import MTAIcon from './MTAIcon'
import SourceGuardIcon from './SourceGuardIcon'
import SourceGuardColoredIcon from './SourceGuardColoredIcon'
import IotFirmwareScanColoredIcon from './IotFirmwareScanColoredIcon'
import AnalystMindIcon from './AnalystMindIcon'
import IotProtectIcon from './IotProtectIcon'
import AppProtectIcon from "./AppProtecticon";

export default {
  'protect,avanan,threat_protection,threat-protection,threat protection': ProtectIcon,
  'identity-and-access': IdentityIcon,
  'asset-management': AssetsIcon,
  'data-security': DlpIcon,
  'visibility-and-control': VisibilityIcon,
  'ato,finger': ATOIcon,
  'identity_protection,identity-protection,identity protection': IdentityProtectionIcon,
  'cloud,cloudia,cloudia-bw': CloudiaIcon,
  'cloudia-colored': CloudiaColoredIcon,
  'gen': MiroIcon,
  'ngen,ngen-colored,miro,miro-colored,infinity2gem,infinity2gem-colored': MiroColoredIcon,
  'cloudguardsaas,cloudguardsaas-colored': CloudGuardSaaSColoredIcon,
  'checkpoint-infinity-portal': CheckpointInfinityPortalIcon,
  'endpoint,endpoint-portal,endpoint_portal,endpoint portal,ep_server_portal,ep_server_portal-colored': EndpointColoredIcon,
  'endpoint-dashboard': EndpointDashboardColoredIcon,
  'sandblastmobile,sandblastmobile-colored': SandblastMobileIcon,
  'appprotect,appprotect-colored': AppProtectIcon,
  'datatube,datatube-colored': DataTubeIcon,
  'maas,maas-colored': MAASIcon,
  'threatprevention,threat-prevention,threat_prevention_portal-colored,threat_prevention_portal': ThreatPreventionIcon,
  'dome9,dome9-colored': Dome9ColoredIcon,
  'mta,mta-colored': MTAIcon,
  'sourceguard-colored': SourceGuardColoredIcon,
  'sourceguard': SourceGuardIcon,
  'iot-firmware-scan,iotFirmwareScanning,iotFirmwareScanning-colored,iotfirmwarescanning,iotfirmwarescanning-colored': IotFirmwareScanColoredIcon,
  'analystmind, analystmind-colored': AnalystMindIcon,
  'iot-protect-colored': IotProtectIcon
}
